import { PageLink } from 'assets/layout/core'

export const breadcrumbView: PageLink[] = [
  {
    title: 'Tipos de item',
    path: '/commercial/dishesTypes',
    isSeparator: false,
    isActive: false
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false
  }
]
